import React from 'react';
import PropTypes from 'prop-types';

export default function Pending({ status }) {
  return (
    <div className="content">
      <section>
        <h1 className="mb-3">Assisted Connection Setup Initiated</h1>

        <p>
          Your assisted connection setup has been initiated. Please complete the required steps
          on your end and wait for the process to finalize. Once completed, you&apos;ll be notified
          and can proceed with using the synchronization features.
        </p>

        <p className="mt-5">
          Connection Status:
          {' '}
          <span className="fw-semibold">{status.status}</span>
        </p>
      </section>
    </div>
  );
}

Pending.propTypes = {
  status: PropTypes.object.isRequired,
};
